import { ptBR, enUS, es } from 'date-fns/locale';
import { useTranslation } from '@/contexts/LanguageContext';
import type { Locale } from 'date-fns';

export function useDateLocale(): Locale {
  const { language } = useTranslation();

  const localeMap: Record<string, Locale> = {
    'pt-BR': ptBR,
    'en-US': enUS,
    'es-ES': es,
  };

  return localeMap[language] || ptBR;
}
